const Theme = {
    colors: {
        
      primary: '#ffff00',
      red: '#ff9999',
      dark: '#000',
      light: '#FFF',
      grey: {
        light: '#F9F9F9',
        main: '#E5E5E5',
        dark: '#7B7B7B',
      },
      hover: {
        primary: '#e6e600',
        red: '#ee8888',
        grey: '#d4d4d4',
        dark: '#333',
      },
      active: {
        primary: '#ffff4d',
        red: '#dd7777',
        grey: '#c3c3c3',
        dark: '#444',
      },
    },
  
    widths: {
      content: '140rem',
    },
  }
  
  export default Theme;